import axios from './axios';
import qs from 'qs';

export default{
    // get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'get',
          url,
          params: param,
        })
        .then((res = {}) => {
          resolve(res);
        })
    });
  },
    // get请求--下载
    getDownLoad(url, param) {
      return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url,
            responseType: 'arraybuffer',
            params: param
            
          })
          .then((res = {}) => {
            resolve(res);
          })
      });
    },
  getBlob(url, param) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'get',
          url,
          params: param,
          responseType: 'blob'
        })
        .then((res = {}) => {
          resolve(res);
        }).catch((err) => {
          resolve(err);
        })
    });
  },
   // post请求
   postJson(url, param, headers) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'post',
          url,
          data: param,
        })
        .then((res = {}) => {
          if (res.code !== 200) reject(res);
          resolve(res);
        })
        .catch((_) => reject(_));
    });
  },
   // url表单请求
   post(url, param, headers) {
    return new Promise((resolve, reject) => {
      axios({
          method: 'post',
          url,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: qs.stringify(param),
        })
        .then((res = {}) => {
          if (res.code !== 200) reject(res);
          resolve(res);
        })
        .catch((_) => reject(_));
    });
  },
   // post表单数据
   postFormData(url, param) {
    const formtData = new FormData();
    for (const k in param) {
      formtData.append(k, param[k]);
    }
    return axios({
      url: url,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formtData,
    });
  },
  delete(url, param){
    return new Promise((resolve, reject) => {
      axios({
          method: 'delete',
          url,
          params: param,
        })
        .then((res = {}) => {
          resolve(res);
        })
    });
  },
  ajax(config) {
    if (config.method.toLowerCase() == 'get') {
        return this.get(config.url, config.data);
    } else {
        if(config.headers){
            return this.postForm(config.url, config.data, config.headers);
        }else{
            return this.post(config.url, config.data, config.headers);
        }
    }
  },
}